import { useMutation } from "@shared/lib/hooks";
import { BriefConfigService } from "../services/briefConfigService";
import { BRIEF_CONFIG_QUERY_KEY } from "@entities/brief/lib/constants";

import { ToastService } from "@shared/lib/services";

export function useSaveDeliverableConfig(briefId: string) {
  const {
    mutate: saveDeliverable,
    isLoading: isSaving,
    isSuccess: isSaved,
    variables,
  } = useMutation({
    mutationFn: ({
      data,
    }: {
      data: { briefId: string; deliverableConfigRefId: string };
    }) =>
      BriefConfigService.saveDeliverableConfig(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({ queryKey: BRIEF_CONFIG_QUERY_KEY(briefId) });
    },
  });

  return {
    saveDeliverable,
    isSaving,
    isSaved,
    variables,
  };
}
